export let Domain;
(function (Domain) {
  Domain["Deutch"] = "de";
  Domain["English"] = "com";
  Domain["Japanese"] = "jp";
  Domain["Spanish"] = "es";
  Domain["French"] = "fr";
})(Domain || (Domain = {}));